import * as React from "react";
import { Button } from "@mui/material";
import { NoButton, YesButton } from "../../views/common-forms/components";
import { ButtonTypes } from "../../shared/timeclock/models";
import { ReactElement } from "react";

interface ConfirmationDialogProps {
    header?: React.ReactNode;
    message?: React.ReactNode;
    question?: string;

    enableOkButton?: boolean;
    enableYesButton?: boolean;
    enableNoButton?: boolean;

    confirmationClickedHandler: (buttonType: ButtonTypes) => void;

    autoConfirmTimeout?: number;
}

export class ConfirmationDialog extends React.Component<ConfirmationDialogProps> {

    timerId: number;

    componentDidMount(): void {
        if (this.props.autoConfirmTimeout) {
            this.timerId = window.setInterval(this.confirmOk, this.props.autoConfirmTimeout);
        }
    }

    componentWillUnmount(): void {
        clearInterval(this.timerId);
    }

    confirmOk = (): void => this.props.confirmationClickedHandler(ButtonTypes.Ok);

    confirmYes = (): void => this.props.confirmationClickedHandler(ButtonTypes.Yes);

    confirmNo = (): void => this.props.confirmationClickedHandler(ButtonTypes.No);

    render(): ReactElement {
        const {
            header,
            message,
            question,
            enableNoButton,
            enableOkButton,
            enableYesButton
        } = this.props;
        
        return (
            <div>
                <div className="tc-message-box">
                    {header && <h2>{header}</h2>}
                    <p> {message && message}</p>
                    {question && question.length > 0 && <p>{question} </p>}
                </div>
                {enableOkButton && <Button variant="contained" className="tc-button" onClick={this.confirmOk}>OK</Button>}
                {enableYesButton && <YesButton onClick={this.confirmYes} />}
                {enableNoButton && <NoButton onClick={this.confirmNo} />}
            </div>
        );
    }
}
